import useGetter from "./useGetter";
import FilesystemListContainer from "./FilesystemListContainer";
import PublicationFigurePanels from "./PublicationFigurePanels";
import { FilesystemStore } from './Contexts';
import NewManualAnnotationGrid from './NewManualAnnotationGrid';
import ManualAnnotationGridTable from './ManualAnnotationGridTable';
import { FilesystemItemContext } from './Contexts';
import FigureFilesystemContainer from "./FigureFilesystemContainer";

import ur from './ur';

import { useState } from 'react';
import { useDispatch} from 'react-redux';

import A from './ActionCreators';
import C from './Constants';

import AddButton from './AddButton';
import RemoveButton from './RemoveButton';

export default function PublicationFigurePanelsListEditor({
  onEvent,
  publication,
  editorState,


}){


  const topLevelDirectoryId = useGetter("getTopLevelDirectoryId",{type:"figurePanels"});

  const [listEditingState,setListEditingState] = ur({});

  const [ figurePanelId, setFigurePanelId ] = useState();

  let {figurePanels} = publication.items;

  const dispatch = useDispatch();


  let listEditor = (
    <div class="full-width full-height rel sg-row">

      <div class="full-height border-right">
        <FilesystemItemContext.Provider value={{
          getItemContext:({item,treePath}) => {
            if( item.type === "figurePanels" ){

              let itemIn = (item._id in figurePanels);




              return ({
                footer:(
                  <div onClick={e => {

                    let type = itemIn ? "removeItem" : "addItem";
                    onEvent({
                      type,
                      item
                    })
                      
                  }}>
                    <div class="sg-row v-center">
                    {itemIn?<RemoveButton style={{ 
                      color:'red',
                      fontSize:18,

                    }} />:<AddButton style={{ 
                      fontSize:18,
                      color:'red',
                      //color:'rgb(0,129,255)'

                      }} 
                      />}
                    </div>
                  </div>
                )
              })

            }
          }
        }}>
          <FilesystemStore.Provider value={{
            onFilesystemItemEvent:({_id,event,item}) => {

              setListEditingState({ figurePanelId:item._id });

            },
            isFilesystemItemSelected:(_id) => {
              return listEditingState.figurePanelId === _id;
            }
          }}>
            <FilesystemListContainer {...{
              topLevelDirectoryId
            }}/>
          </FilesystemStore.Provider>
        </FilesystemItemContext.Provider>
      </div>



      <div class="">
        {figurePanelId && (<ManualAnnotationGridTable {...{
          figurePanelId,
          editable:false,
          tableOutlineShowing:false,
        }}/>)}
        {false && <div>
          <pre>
            {JSON.stringify(figurePanels,null,1)}
          </pre>
        </div>}

      </div>



      






    </div>
  )


  return listEditor;
}

